import React from "react";
import "../../scss/customerpolicy/policies.scss";


function Policy() {
  return (
    <div className="Policy">
      <div className="container">
        <div className="Content">
          <div className="head">
            <br></br>
            <p>
              Welkom bij Decoratie Degezelle. Wij hechten waarde aan uw privacy
              en willen u duidelijk uitleggen hoe wij uw persoonlijke informatie
              verzamelen, gebruiken, delen en beschermen. Dit privacybeleid is
              van toepassing op de informatie die wij verzamelen wanneer u onze
              website bezoekt, onze diensten gebruikt, of op andere wijze met
              ons communiceert (gezamenlijk de "Diensten"). Door gebruik te
              maken van onze Diensten stemt u in met de praktijken die in dit
              privacybeleid worden beschreven.
            </p>
          </div>
          <div className="policy1">
            <h2>1. Welke informatie verzamelen wij?</h2>
            <p>
              Wij verzamelen persoonlijke informatie die u vrijwillig aan ons
              verstrekt, zoals uw naam, e-mailadres, telefoonnummer en andere
              contactgegevens. Daarnaast kunnen wij informatie verzamelen over
              uw gebruik van onze Diensten, zoals het type browser dat u
              gebruikt, de bezochte pagina's, de door u gebruikte apparaten en
              andere diagnostische gegevens.
            </p>
            <br></br>
          </div>
          <div className="policy2">
            <h2>2. Hoe gebruiken wij uw informatie?</h2>
            <p>
              Wij kunnen uw persoonlijke informatie gebruiken voor de volgende
              doeleinden:
            </p>
            <ul>
              <li>
                Om u te voorzien van de gevraagde Diensten en klantenservice.
              </li>
              <li>
                Om u op de hoogte te houden van onze producten, diensten,
                aanbiedingen en promoties.
              </li>
              <li>
                Om analyses uit te voeren en trends te volgen om onze Diensten
                te verbeteren.
              </li>
              <li>
                Om contact met u op te nemen en te reageren op uw vragen,
                opmerkingen of verzoeken.
              </li>
            </ul>
            <br></br>
          </div>
          <div className="policy3">
            <h2>3. Openbaarmaking van informatie</h2>
            <p>
              Wij zullen uw persoonlijke informatie niet delen, verkopen,
              verhuren of anderszins openbaar maken aan derden, behalve zoals
              beschreven in dit privacybeleid of met uw voorafgaande
              toestemming.
            </p>
            <br></br>
          </div>
          <div className="policy4">
            <h2>4. Uw keuzes</h2>
            <p>
              U heeft het recht om te kiezen of u informatie met ons wilt delen.
              U kunt ervoor kiezen om bepaalde persoonlijke informatie niet te
              verstrekken, maar houd er rekening mee dat dit van invloed kan
              zijn op uw gebruik van onze Diensten.
            </p>
            <br></br>
          </div>
          <div className="policy5">
            <h2>5. Veiligheid</h2>
            <p>
              Wij nemen redelijke maatregelen om uw persoonlijke informatie te
              beschermen tegen ongeoorloofde toegang, gebruik of openbaarmaking.
              Ondanks onze inspanningen kunnen wij echter niet garanderen dat de
              informatie veilig is.
            </p>
            <br></br>
          </div>
          <div className="policy6">
            <h2>6. Wijzigingen in dit privacybeleid</h2>
            <p>
              Wij behouden ons het recht voor om dit privacybeleid op elk moment
              bij te werken of te wijzigen. Wanneer wij wijzigingen aanbrengen,
              zullen wij de datum van de laatste wijziging bijwerken.
            </p>
            <br></br>
            <p>
              Als u vragen heeft over dit privacybeleid, neem dan contact met
              ons op via <span className="bold">+32 0478 36 60 70.</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Policy;
